import type { IUser } from '../services/users/types';
import { isConsultant, isCustomer } from './isProfile';

/** Posto (customer) — sujeito a trial, billing-status e GET /customers/me. */
export const isCustomerBillingProfile = (user: IUser | null | undefined): boolean =>
  Boolean(user && isCustomer(user));

/** Consultor — entitlement próprio; não usar gate de assinatura do posto. */
export const shouldSkipCustomerBillingFlow = (user: IUser | null | undefined): boolean =>
  Boolean(user && isConsultant(user));
